
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CustomFormField } from '@/components/ui/custom-form-field';
import { Form } from '@/components/ui/form';
import { useForm } from 'react-hook-form';
import { useAuth } from '@/context/AuthContext';
import { Input } from '@/components/ui/input';
import { Camera } from 'lucide-react';

const ProfileSettings = () => {
  const { user } = useAuth();
  
  const form = useForm({
    defaultValues: {
      name: user?.name || '',
      email: user?.email || '',
      title: 'Marketing Director',
      phone: '+1 (555) 123-4567',
      bio: 'Experienced marketing professional with a focus on digital strategy and content marketing.'
    }
  });
  
  const onSubmit = (data: any) => {
    console.log('Profile form submitted:', data);
    // Here you would typically update the user's profile
  };
  
  return (
    <div className="max-w-3xl">
      <Card>
        <CardHeader>
          <CardTitle>Profile Information</CardTitle>
          <CardDescription>
            Update your personal information and how it appears across the platform.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
              <div className="flex flex-col md:flex-row gap-6">
                <div className="md:w-1/3 flex flex-col items-center">
                  <div className="relative">
                    <div className="h-32 w-32 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden border-2 border-white shadow-md">
                      <span className="text-4xl font-semibold text-gray-400">
                        {user?.name ? user.name.charAt(0).toUpperCase() : 'U'}
                      </span>
                    </div>
                    <Button size="icon" className="absolute bottom-0 right-0 rounded-full h-8 w-8">
                      <Camera className="h-4 w-4" />
                    </Button>
                  </div>
                  <p className="text-sm text-muted-foreground mt-2">
                    Click the camera icon to upload a new photo
                  </p>
                </div>
                
                <div className="md:w-2/3 space-y-4">
                  <CustomFormField
                    form={form}
                    name="name"
                    label="Full Name"
                    placeholder="Your name"
                    required
                  />
                  
                  <CustomFormField
                    form={form}
                    name="email"
                    label="Email"
                    type="email"
                    placeholder="Your email address"
                    required
                  />
                  
                  <CustomFormField
                    form={form}
                    name="title"
                    label="Job Title"
                    placeholder="Your position"
                  />
                  
                  <CustomFormField
                    form={form}
                    name="phone"
                    label="Phone Number"
                    placeholder="Your phone number"
                  />
                  
                  <CustomFormField
                    form={form}
                    name="bio"
                    label="Bio"
                    type="textarea"
                    placeholder="Tell us about yourself"
                    rows={4}
                  />
                </div>
              </div>
              
              <div className="flex justify-end gap-2">
                <Button variant="outline" type="button">Cancel</Button>
                <Button type="submit">Save Changes</Button>
              </div>
            </form>
          </Form>
        </CardContent>
      </Card>
    </div>
  );
};

export default ProfileSettings;
